import dayjs from "@eisox/dayjs";
import { z } from "@eisox/zod";

import { Mode } from "~/components/live-history-toggle";

const isValidIsoDate = (value: string): boolean => dayjs(value).isValid();

export const planHistorySearchSchema = z.object({
  mode: z.enum(Mode).default(Mode.Live).catch(Mode.Live),
  date: z
    .string()
    .optional()
    .refine(value => value === undefined || isValidIsoDate(value), { message: "Invalid ISO date" })
    .catch(undefined),
});

export type PlanHistorySearch = z.infer<typeof planHistorySearchSchema>;

export interface HistoryDateChangeOptions {
  replace?: boolean;
}

export const toPlanHistorySearch = (mode: Mode, date?: string): PlanHistorySearch => {
  if (mode === Mode.Live) {
    return { mode };
  }

  return date ? { mode, date } : { mode };
};

export const isSameHistoryDate = (a: string | undefined, b: string | undefined): boolean => a === b;
